export class CreateTipoPunitorioRequest{
    public descripcion: string = ""
    public valor:number= 0
}